import { HomeCta } from 'src/features/home-page/components/HomeCta/HomeCta';

export const HalfTextHalfImageSlice = ({ primary }: any) => {
  const props = {
    title: primary.title[0]?.text,
    body: primary.body1[0]?.text,
    ctaLabel: primary.cta_text,
    ctaHref: primary.cta_link?.url,
    src: primary.image?.url,
    imgContainerClassName: 'md:mr-3xl',
    imgClassName: '',
    isInverted: primary.invertOrder,
  };
  return (
    <div className="container">
      <HomeCta {...props} />
    </div>
  );
};
